import type { GridInterface } from '@ad-lucy/context/adData';

import { defineGrid } from './defineGrid';

export const grid1x1 = (): GridInterface[] =>
  defineGrid(
    '1:1',
    [
      {
        name: 'Sitebar',
        rows: [
          {
            columns: [
              {
                tileId: 1,
                spanCol: 2,
              },
              {
                tileId: 2,
                spanCol: 2,
              },
            ],
          },
          {
            columns: [
              {
                tileId: 3,
              },
              {
                tileId: 4,
              },
            ],
          },
        ],
      },
    ],
    2,
    2,
  );
